export const julyUppercase = "goW$B";
export default {julyUppercase};